<template>
  <div class="content">
    <div class="bodycontent">
      <div class="boxposition page1">
        <!-- 为相对定位 -->
        <!-- 进度条 -->
        <Progress :status=progressStatus></Progress>
        <!-- 第一页 -->
        <div class="page1" v-if="progressStatus == 1">
          <!-- 基本信息 -->
          <div class="box1Progress">
            <p class="title">基本信息</p>
            <!-- 商品所有类别 -->
            <div class="classify">
              <div
                :class="choseIndex == 0 ? 'classifyItem opt' : 'classifyItem'"
                @click="clickchose(0)"
              >
                <p>实物发货</p>
                <p>(物流发货)</p>
                <span
                  class="iconfont iconxuanzhongjiaobiao1"
                  v-if="choseIndex == 0"
                ></span>
              </div>
              <div
                :class="choseIndex == 1 ? 'classifyItem opt' : 'classifyItem'"
                @click="clickchose(1)"
              >
                <p>虚拟商品</p>
                <p>(无需物流)</p>
                <span
                  class="iconfont iconxuanzhongjiaobiao1"
                  v-if="choseIndex == 1"
                ></span>
              </div>
              <div
                :class="choseIndex == 2 ? 'classifyItem opt' : 'classifyItem'"
                @click="clickchose(2)"
              >
                <p>电子卡券</p>
                <p>(无需物流)</p>
                <span
                  class="iconfont iconxuanzhongjiaobiao1"
                  v-if="choseIndex == 2"
                ></span>
              </div>
              <div
                :class="choseIndex == 3 ? 'classifyItem opt' : 'classifyItem'"
                @click="clickchose(3)"
              >
                <p>酒店商品</p>
                <p>(无需物流)</p>
                <span
                  class="iconfont iconxuanzhongjiaobiao1"
                  v-if="choseIndex == 3"
                ></span>
              </div>
              <div
                :class="choseIndex == 4 ? 'classifyItem opt' : 'classifyItem'"
                @click="clickchose(4)"
              >
                <p>蛋糕烘焙</p>
                <p>(同城送或自提)</p>
                <span
                  class="iconfont iconxuanzhongjiaobiao1"
                  v-if="choseIndex == 4"
                ></span>
              </div>
            </div>
            <!-- 当前类目 -->
            <div class="present">
              <div class="block">
                <p class="demonstration">当前类目：</p>
                <!-- 切换类目弹窗 -->
                <div class="block">
                  <el-cascader
                    v-model="cateValue"
                    :props="defaultCate"
                    :options="catedata"
                    @change="handleChangeCate"
                    size="mini"
                  >
                  </el-cascader>
                </div>
                <!-- <p>女装/女士精品>>中老年女装</p>
                <p class="link" @click = "cate">切换</p> -->
              </div>
            </div>
            <!-- 商品信息 -->
            <div class="message">
              <ul class="messageUl">
                <li class="messageIl">
                  <p class="lileft">宝贝类别：</p>
                  <div class="liright">
                    <el-radio v-model="initdata.is_new" label="0">全新</el-radio>
                    <el-radio v-model="initdata.is_new" label="1">二手</el-radio>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">
                    <span class="redopt iconfont iconjiufuqianbaoicon14"></span>
                    宝贝标题：
                  </p>
                  <p class="liright">
                    <el-input type="text" size="mini" v-model="initdata.name" class="longinput"></el-input>
                  </p>
                </li>
                <li class="messageIl">
                  <p class="lileft">
                    <span class="redopt iconfont iconjiufuqianbaoicon14"></span>
                    商品类型：
                  </p>
                  <div class="liright">
                    <span>
                      <el-select
                        v-model="initdata.goods_type"
                        placeholder="请选择商品类型"
                        size="mini"
                        @change ="is_specMessageBox" 
                      >
                        <el-option
                          v-for="item in goodsType"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </span>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">商品规格：</p>
                  <div class="liright">
                    <el-radio v-model="initdata.is_spec" label="0">统一规格</el-radio>
                    <el-radio v-model="initdata.is_spec" label="1">多规格</el-radio>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">商品图片：</p>
                  <div class="liright">
                    <el-upload
                      ref="upload"
                      list-type="picture-card"
                      action="#"
                      :http-request="(file)=> { return productUploadImg(file) }"
                      :on-preview="handlePictureCardPreview"
                      :on-remove="handleRemove"
                      :file-list="fileListData"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt="" />
                    </el-dialog>
                    <p style="margin-top:10px;">
                      尺寸建议750*750（正方形模式）或750*1000（长图模式）像素以上，大小2M以下，最多10张（可拖拽图片调整显示顺序）
                    </p>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">主图视频：</p>
                  <div class="liright flex" >
                    <video controls :src="videoUrl" v-if="is_video">
                    </video>
                    <label for="male" class="videdo">
                      <div class="videobox" v-if ="!is_video">
                        <i class="el-icon-plus"></i>
                      </div>
                      <div class="againvideo" v-else>
                        <p class="but">重新上传</p>
                        <p>仅支持mp4格式的视频，且不超过10M</p> 
                      </div>
                    </label>
                    <input type="file" id="male" @change="changeVideo()" ref="videitem" style="display:none">
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 销售信息 -->
          <div class="box2Progress">
            <p class="title">销售信息</p>
            <div class="message">
              <ul class="messageUl">
                <!-- 统一规格 -->
                <div v-if="is_specOption">
                  <li class="messageIl">
                    <p class="lileft">销售价：</p>
                    <div class="liright averageLayout">
                      <span><el-input class="smalllength" type="number" size="mini" v-model="initdata.price"></el-input></span>
                      <span>成品价：<el-input type="number" class="smalllength" size="mini" v-model="initdata.costprice"></el-input></span>
                      <span>市场价：<el-input type="number" class="smalllength" size="mini" v-model="initdata.mktprice"></el-input></span>
                    </div>
                  </li>
                  <li class="messageIl">
                    <p class="lileft">已出售数量：</p>
                    <div class="liright">
                      <el-input size="mini" class="smallinput margin" type="number" v-model="initdata.init_sale_num"></el-input>
                      <el-checkbox v-model="is_sales"><span style="font-size:12px;">显示销售数量</span></el-checkbox>
                    </div>
                  </li>
                  <li class="messageIl">
                    <p class="lileft">商品库存：</p>
                    <div class="liright">
                      <el-input size="mini" class="smallinput" type="number" v-model="initdata.stock"></el-input>
                    </div>
                  </li>
                </div>
                <!-- 多规格 -->
                <div v-else>
                  <li class="messageIl ">
                    <p class="lileft">商品规格：</p>
                    <div class="liright">
                      <table class="speclist">
                        <thead>
                          <tr>
                            <td>默认货品</td>
                            <td>图片</td>
                            <td>编号</td>
                            <td>规格</td>
                            <td>库存</td>
                            <td>销售价</td>
                            <td>成本价</td>
                            <td>市场价</td>
                            <td>操作</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(item, index) in specOptiondata"
                            :key="index">
                            <td>
                              <el-checkbox
                                class="defaultSpec"
                                v-model="item.is_defalut"
                                @change="changeIsDefault(index)"
                              >
                                是否默认
                              </el-checkbox>
                            </td>
                            <td name="imageSpec">
                              <el-upload
                                class="avatar-uploader"
                                action="#"
                                :show-file-list="false"
                                :http-request="(file)=>{return upload_index_img(file, index)}"
                                style="background:#fff;"
                              >
                                <img v-if="item.imageUrl" :src="item.imageUrl" class="avatar" style="width:100%">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                              </el-upload>
                            </td>
                            <td><input placeholder="编号" name="snSpec" v-model="item.sn" /></td>
                            <td name="spes_descSpec">{{item.spes_desc}}</td>
                            <td><input placeholder="库存" name="stockSpec" type="number"  v-model="item.stock"/></td>
                            <td><input placeholder="销售价" name="priceSpec" type="number"  v-model="item.price"/></td>
                            <td><input placeholder="成本价" name="costpriceSpec" type="number"  v-model="item.costprice"/></td>
                            <td><input placeholder="市场价" name="mktpriceSpec" type="number"  v-model="item.mktprice"/></td>
                            <td><el-button type="info" size="mini" @click="delectSpec(index)">删除</el-button></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <div class="box2Progress">
            <p class="title">配送信息</p>
            <!-- 商品信息 -->
            <div class="message">
              <ul class="messageUl">
                <li class="messageIl">
                  <p class="lileft">是否包邮：</p>
                  <div class="liright">
                    <el-radio-group v-model="postage_free_ship" @change="changeMethods">
                      <el-radio label="0">是</el-radio>
                      <el-radio label="1">否</el-radio>
                    </el-radio-group>
                  </div>
                </li>
                <div class="box" v-if="postage_free_ship == '1'? true: false">
                  <li class="messageIl">
                    <p class="lileft">快递方式：</p>
                    <div class="liright">
                      <el-radio-group v-model="initdata.send_method">
                        <el-radio label="1">统一配送</el-radio>
                        <!-- <el-radio label="0">商家配送</el-radio>  预留-->
                      </el-radio-group>
                    </div>
                  </li>
                  <li class="messageIl">
                    <p class="lileft">
                      运费设置：
                    </p>
                    <p class="liright">
                      <span>
                        <el-select
                          v-model="initdata.send_tlp_id"
                          placeholder="请选择运费模板"
                          @visible-change="focusHint(2, freightdata)"
                          size="mini"
                          disabled="disabled"
                        >
                          <el-option
                            v-for="item in freightdata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                        <span class="link" @click="refersh">刷新</span>
                        <span class="link" @click="windowOpen(1)">新增</span>
                        <!-- <span class="link">模板</span> -->
                      </span>
                    </p>
                  </li>
                </div>
                
              </ul>
            </div>
          </div>
        </div>
        <!-- 第二页 -->
        <div class="page2" v-if="progressStatus == 2">
          <div class="box2Progress">
            <!-- 商品信息 -->
            <div class="message">
              <ul class="messageUl">
                <li class="messageIl">
                  <p class="lileft">商品分组：</p>
                  <div class="liright flex">
                    <div class="groupcontent secondLength radious">
                      <el-select
                        v-model="initdata.goods_group_id"
                        class="secondLength"
                        size="mini"
                        @focus="getgroupList"
                        placeholder="请选择"
                      >
                        <el-option-group
                          v-for="group in groupdata"
                          :key="group.id"
                          :label="group.name">
                          <el-option
                            v-for="item in group.child"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          >
                          </el-option>
                        </el-option-group>
                      </el-select>
                    </div>
                    <div class="link" @click="windowOpen(2)">新增分组</div>
                    <!-- <el-popover
                      ref="groupcontents"
                      placement="bottom"
                      width="400"
                      trigger="click">
                      <ul class="grouplist">
                        <li>
                          <dl>
                            <dt>系统分组</dt>
                            <dd>热销排行</dd>
                            <dd>热销排行</dd>
                          </dl>
                        </li>
                        <li>
                          <dl>
                            <dt>默认分组</dt>
                            <dd>热销排行</dd>
                          </dl>
                        </li>
                      </ul>
                    </el-popover> -->
                  </div>
                </li>
<!-- dfvdvdfvgdf属性<-- !->                 -->
                <li class="messageIl">
                  <p class="lileft">筛选项：</p>
                  <div class="liright chooseButton paddings">
                    <el-button @click="setFilter" size="small">设置</el-button>
                  </div>
                </li>
                <li class="messageIl" v-if="choseData.length > 0">
                  <p class="lileft"></p>
                  <div class="liright paddings flex">
                    <div style="padding-right:5px"
                      v-for="i in choseData"
                      :key=i.id
                    >
                      <el-tag
                        type="warning"
                        size="mini"
                      >
                        {{ i.name }}
                      </el-tag>
                    </div>
                  </div>
                </li>
<!-- dfvdvdfvgdf内部属性<-- !->                 -->
                <li class="messageIl">
                  <p class="lileft">商品内部属性：</p>
                  <div class="liright chooseButton paddings">
                    <!-- 选中的内容储存区域 -->
                    <div class="stockpile">
                      <ul class="stockpileUl"
                      >
                        <li
                          class="stockpileLi flex"
                          v-for="(item, index) in drawww"
                          :key = "index"
                        >
                          <p class="name">{{item.name}}</p>
                          <el-select
                            v-model="item.val"
                            filterable
                            placeholder="请选择"
                            size="mini"
                            style="width:200px"
                            @change="$set(drawww, index , drawww[index])"
                          >
                            <div class="import" style="display:flex;color:#ccc;fontsize:12px;font-weight:500">
                              <input type="text" placeholder="请选择或者输入值" name="innerattritemValue" value="">
                              <div class="newbutton" @click="addattrValueitem(3, item.id, index)">新增</div>
                            </div>
                            <!-- <el-option value="">
                              <div>
                                <p class="el-select-dropdown__item selected">暂未搜索到结果</p>
                                <p class="el-select-dropdown__item selected">您可新增关键词到列表</p>
                              </div>
                            </el-option> -->
                            <el-option
                              v-for="item in ww[index]"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                          <p class="delete link" @click="drawattrDelect(3, index)">移除</p>
                        </li>
                      </ul>
                    </div>
                    <!-- 操作区域 -->
                    <div class="operater flex">
                        <!-- 新增属性 -->
                        <div>
                          <span v-if="show_replaceInnerAttrNEW" @click="replaceNEW(3)" class="replaceNEWitem1" id="replaceNEWitem2">
                            <el-button size="mini" plain type="primary" icon="el-icon-plus">新增属性</el-button>
                          </span>
                          <span v-else>
                            <!-- 输入区域 -->
                            <div class="import flex">
                              <input type="text" placeholder="请选择或者输入值" v-popover:innerattributeValue @click="againshopdatat(3)" name="innerattritemName" value=" ">
                              <div class="newbutton" @click="addattritem(3)">新增</div>
                            </div>
                            <!-- 获取的数据 -->
                            <el-popover
                              ref="innerattributeValue"
                              placement="bottom"
                              width="204"
                              trigger="click">
                              <div class="ajaxdata">
                                <div class="empty" v-if="innerhtmldata.length == 0 ">
                                  <p>暂未搜索到结果</p>
                                  <p>您可新增关键词到列表</p>
                                </div>
                                <ul class="have"
                                  v-else
                                  v-for="(item, index) in innerhtmldata"
                                  :key = item.id
                                >
                                  <li @click="addstockItem(3, index, item.id,item.name)">{{item.name}}</li>
                                </ul>
                              </div>
                            </el-popover>
                          </span>
                        </div>
                        <span>内部属性只用于向订单及第三方系统传参，不作为筛选，也不在微信端商品详情展示</span>
                    </div>
                  </div>
                </li>
<!-- dfvdvdfvgdf参数<-- !->                 -->
                <li class="messageIl">
                  <p class="lileft">商品参数：</p>
                  <div class="liright chooseButton paddings">
                    <!-- 选中的内容储存区域 -->
                    <div class="stockpile">
                      <ul class="stockpileUl"
                      >
                        <li
                          class="stockpileLi flex"
                          v-for="(item, index) in drawParamList"
                          :key = "index"
                        >
                          <p class="name">{{item.name}}</p>
                          <el-select
                            v-model="item.val"
                            filterable
                            placeholder="请选择"
                            size="mini"
                            style="width:200px"
                            @change="$set(drawParamList, index , drawParamList[index])"
                          >
                            <div class="import" style="display:flex;color:#ccc;fontsize:12px;font-weight:500">
                              <input type="text" placeholder="请选择或者输入值" name="paramitemValue" value="">
                              <div class="newbutton" @click="addattrValueitem(4, item.id, index)">新增</div>
                            </div>
                            <!-- <el-option value="">
                              <div>
                                <p class="el-select-dropdown__item selected">暂未搜索到结果</p>
                                <p class="el-select-dropdown__item selected">您可新增关键词到列表</p>
                              </div>
                            </el-option> -->
                            <el-option
                              v-for="item in drawParamValueList[index]"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                          <p class="delete link" @click="drawattrDelect(4, index)">移除</p>
                        </li>
                      </ul>
                    </div>
                    <!-- 操作区域 -->
                    <div class="operater flex">
                        <!-- 新增属性 -->
                        <div>
                          <span v-if="show_replaceParamNEW" @click="replaceNEW(4)" class="replaceNEWitem1" id="replaceNEWitem2">
                            <el-button size="mini" plain type="primary" icon="el-icon-plus">新增属性</el-button>
                          </span>
                          <span v-else>
                            <!-- 输入区域 -->
                            <div class="import flex">
                              <input type="text" placeholder="请选择或者输入值" v-popover:paramibuteValue @click="againshopdatat(4)" name="paramitemName" value=" ">
                              <div class="newbutton" @click="addattritem(4)">新增</div>
                            </div>
                            <!-- 获取的数据 -->
                            <el-popover
                              ref="paramibuteValue"
                              placement="bottom"
                              width="204"
                              trigger="click">
                              <div class="ajaxdata">
                                <div class="empty" v-if="getParamList.length == 0 ">
                                  <p>暂未搜索到结果</p>
                                  <p>您可新增关键词到列表</p>
                                </div>
                                <ul class="have"
                                  v-else
                                  v-for="(item, index) in getParamList"
                                  :key = item.id
                                >
                                  <li @click="addstockItem(4, index, item.id,item.name)">{{item.name}}</li>
                                </ul>
                              </div>
                            </el-popover>
                          </span>
                        </div>
                        <span>增加参数和参数值后请勿随意删除，删除后其他引用该参数值的商品也将不显示该参数 </span>
                    </div>
                  </div>
                </li>
<!-- dfvdvdfvgdf服务<-- !->                 -->
                <li class="messageIl">
                  <p class="lileft">商品服务：</p>
                  <div class="liright chooseButton paddings">
                    <!-- 选中的内容储存区域 -->
                    <div class="stockpile">
                      <ul class="stockpileUl"
                      >
                        <li
                          class="stockpileLi flex"
                          v-for="(item, index) in drawServeList"
                          :key = "index"
                        >
                          <p class="name">{{item.name}}</p>
                          <el-select
                            v-model="item.val"
                            filterable
                            placeholder="请选择"
                            size="mini"
                            style="width:200px"
                            @change="$set(drawServeList, index , drawServeList[index])"
                          >
                            <div class="import" style="display:flex;color:#ccc;fontsize:12px;font-weight:500">
                              <input type="text" placeholder="请选择或者输入值" name="serveitemValue" value="">
                              <div class="newbutton" @click="addattrValueitem(5, item.id, index)">新增</div>
                            </div>
                            <!-- <el-option value="">
                              <div>
                                <p class="el-select-dropdown__item selected">暂未搜索到结果</p>
                                <p class="el-select-dropdown__item selected">您可新增关键词到列表</p>
                              </div>
                            </el-option> -->
                            <el-option
                              v-for="item in drawServeValueList[index]"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id">
                            </el-option>
                          </el-select>
                          <p class="delete link" @click="drawattrDelect(5, index)">移除</p>
                        </li>
                      </ul>
                    </div>
                    <!-- 操作区域 -->
                    <div class="operater flex">
                        <!-- 新增属性 -->
                        <div>
                          <span v-if="show_replaceServeNEW" @click="replaceNEW(5)" class="replaceNEWitem1" id="replaceNEWitem2">
                            <el-button size="mini" plain type="primary" icon="el-icon-plus">新增属性</el-button>
                          </span>
                          <span v-else>
                            <!-- 输入区域 -->
                            <div class="import flex">
                              <input type="text" placeholder="请选择或者输入值" v-popover:serveibuteValue @click="againshopdatat(5)" name="serveitemName" value=" ">
                              <div class="newbutton" @click="addattritem(5)">新增</div>
                            </div>
                            <!-- 获取的数据 -->
                            <el-popover
                              ref="serveibuteValue"
                              placement="bottom"
                              width="204"
                              trigger="click">
                              <div class="ajaxdata">
                                <div class="empty" v-if="getServeList.length == 0 ">
                                  <p>暂未搜索到结果</p>
                                  <p>您可新增关键词到列表</p>
                                </div>
                                <ul class="have"
                                  v-else
                                  v-for="(item, index) in getServeList"
                                  :key = item.id
                                >
                                  <li @click="addstockItem(5, index, item.id,item.name)">{{item.name}}</li>
                                </ul>
                              </div>
                            </el-popover>
                          </span>
                        </div>
                        <span class="link">查看示例</span>
                    </div>
                  </div>
                </li>
<!-- dfvdvdfvgdf   end<-- !->                 -->
                <li class="messageIl">
                  <p class="lileft">商品标签：</p>
                  <div class="liright flex">
                    <div class="operater">
                      <span>
                        <el-select
                          v-model="initdata.label_ids"
                          placeholder="请选择"
                          @focus="getlabeldata"
                          size="mini">
                          <el-option
                            v-for="item in labeldata"
                            :key="item.id"
                            :label="item.value"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">每人限购</p>
                  <div class="liright flex">
                    <span>特价限购商品请使用<span class="link">限时折扣</span>来实现</span>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">库存计算方式：</p>
                  <div class="liright">
                    <el-radio-group v-model="initdata.cal_stock_meth">
                      <el-radio label="0">下单成功减</el-radio>
                      <el-radio label="1">操作成功减</el-radio>
                    </el-radio-group>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">上架时间：</p>
                  <div class="liright">
                    <el-radio-group v-model="initdata.marketable">
                      <el-radio label="1">立即上架</el-radio>
                      <el-radio label="2">暂不上架</el-radio>
                    </el-radio-group>
                  </div>
                </li>
                <li class="messageIl">
                  <p class="lileft">商品品牌：</p>
                  <div class="liright flex">
                    <div class="operater">
                      <span>
                        <el-select
                          v-model="initdata.brand_id"
                          placeholder="请选择品牌"
                          size="mini"
                          @focus="getBrandList"
                        >
                          <el-option
                            v-for="item in branddata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- 第二页结束 -->
        <!-- 第三页 -->
        <div class="page3" v-if="progressStatus == 3">
          <div class="box2Progress">
            <EditorBar :isClear="isClear" @change="changeeditor" v-model="initdata.intro"></EditorBar>
          </div>
        </div>
        
        <!-- 第三页结束 -->
      </div>
    </div>
    <!-- 操作按钮 -->
    <div class="next">
      <el-button type="primary" size="mini" @click="operation(0)" v-show="progressStatus == 3">取消</el-button>
      <el-button type="primary" size="mini" @click="operation(1)" v-show="progressStatus != 1">上一步</el-button>
      <el-button type="primary" size="mini" @click="operation(2)" v-show="progressStatus != 3">下一步</el-button>
      <el-button type="primary" size="mini" @click="operation(3)" v-show="progressStatus ==3">保存</el-button>
    </div>
    <!-- 添加商品属性 -->
    <!-- <el-dialog :visible.sync="addAttrPop" width="30%" title="添加商品属性"> -->
      <!-- <Popattr></Popattr> -->
    <!-- </el-dialog> -->
    <!-- 添加商品内部属性 -->
    <el-dialog :visible.sync="is_collectPop" width="30%" :title="'添加' + collectPopTitle">
      <collectparam :classid="collectPopId" :title="collectPopTitle" :nameValue="collectPopValue" @closePop="Fclose"></collectparam>
    </el-dialog>
    <el-dialog
      title="添加筛选项"
      :visible.sync="is_filter"
      width="50%"
    >
      <div class="contFilter">
        <div class="leftF">
            <div class="box" >
              <div class="topF">
                <el-button
                  v-for= "(items, index) in catedataitem"
                  :key=items.id @click="cutConF(index)"
                  size="mini"
                >
                  {{items.name}}
                </el-button>
              </div>
              <div
                v-for= "(boxitem, index) in catedataitem"
                :key=boxitem.id
                :class="is_check == index ? 'current contF': 'contF'"
                v-show="is_check == index ? true: false"
              >
                <div class="all">
                  <el-checkbox :indeterminate="isIndeterminate[index]" v-model="checkallss[index]" @change="handleCheckAllChange($event, index)">全选</el-checkbox>
                </div>
                <div class="seed">
                  <el-checkbox-group v-model="choseCheckout[index]" size="small"  @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="namebox in boxitem.params" :label="namebox.id" :key="namebox.id">{{namebox.name}}</el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          <!-- </div> -->
        </div>
        <div class="rightF">
          <div>已选择<span>{{choseData.length}}</span>个</div>
          <div class="chose">
              <el-checkbox v-for="c in choseData" v-model="is_filter" :key="c.id" >{{c.name}}</el-checkbox>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="is_filter = false">取 消</el-button>
        <el-button type="primary" @click="is_filter = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import BScroll from "better-scroll";
import Progress from "@Components/commodity/progress";
import EditorBar from '@Components/public/wangEnduit';
// 添加弹窗集合
import collectparam from "@Components/commodity/collectparam";
// import UploadImages from "@/components/UploadImages/UploadImages";
import {
  TypeList, Getspec, editProduct, addVideo, AttrList, acquireProduct,
  getAttrValueApi, getAddAttrValueApi,
  getInnerAttrNameApi, getInnerAttrValueApi, getAddInnerAttrValueApi,
  getServeNameApi, getServeValueApi, getAddServeValueApi,
  getParamNameApi, getParamValueApi, getAddParamValueApi,
  getLabeldataApi, getAddLabeldataApi, BrandList, groupList, addImage,
  getCateApi, getDeatil
} from "@/api/mall";
import { getFreights, showPostageSet } from "@/api/express"
import { mapGetters, mapActions } from "vuex";
export default {
  components:{
    Progress,
    EditorBar,
    collectparam
  },
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"])
  },
  data () {
    return {
      catedataitem:[],
      is_check: 0,
      checkallss: [],
      choseCheckout:  [],
      choseData:  [],
      isIndeterminate: [],
      is_filter: false,
      //编辑的初始化数据
      initdata:[],
      idE:this.$route.query.idE,
      progressStatus:"1", //页面状态
      cateValue: "",
      defaultCate:{
        label:"name",
        value:"id",
        children:"child",
      },
      catedata:[], //分类数据
      judecate: false,
      postage_free_ship: "0",//快递方式
      freightdata:[], //模板
      viewFreight:[],//
      load: false,
      goodsType:[], //商品类型
      groupdata:[], //商品分组数据
      labeldata:[], //标签数据
      branddata:[], //品牌数据
      is_specOption:true, //商品规格的状态 true 统一规格 false 多规格
      is_sales:false, //商品规格的状态 true 统一规格 false 多规格
      specOptiondata:[], //规格组合数据
      imageUrl: "", //上传图片
      videoUrl:"", //视频上传地址
      is_video:false, //是否已上传视频
      videodata:{}, //视频上传携带的参数
      chosepictireid:[], //已上传图片id数组暂存
      productfileListData:[],//上传文件列表
      fileListData:[], //filelist列表
      fakefileList: [], //假的filelist列表
      choseIndex: 0,
      show_replaceAttrNEW:true, //是否替换新增的属性->属性
      getattrList:[], //商品属性列表
      drawattrList:[], //选中的商品属性存储列表
      drawattrValueList:[], //对应的商品属性值的列表
      // addAttrPop: false, //增加属性弹窗
      show_replaceParamNEW:true, //以下参数
      getParamList:[],
      drawParamList:[],
      drawParamValueList:[],
      //参数end
      show_replaceInnerAttrNEW:true,//以下内部参数
      innerhtmldata:[],
      drawww:[],
      ww:[],
      //内部参数end
      show_replaceServeNEW:true, //以下服务
      getServeList:[],
      drawServeList:[],
      drawServeValueList:[],
      //服务end

      //添加弹窗集合
      collectPopId: 0,
      collectPopTitle: "",
      is_collectPop: false,
      collectPopValue: "",
      goods_attr: "",//属性
      goods_inner_attr: "",//内部属性
      goods_params: "",//参数
      goods_service: "",//服务
      // 上传商品图片
      dialogImageUrl: "",
      dialogVisible: false,
      radio: "",
      // 编辑器
      isClear: false,
      detail: "",
      // 修改商品属性
      amend1: false,
      // 新增
      addButton1: false,
      // 新增属性
      add1: false,
      // isajaxdata
      isajaxdata: true
    };
  },
  watch: {
    // 开启多规格
    "initdata.is_spec": function(val) {
      if (val == 0) {
        this.is_specOption = true;
      } else {
        if (this.initdata.goods_type == "") {
          this.$message({
            message: "您还没有选择商品类型，请选择商品类型！",
            type: "warning"
          });
          this.initdata.is_spec = "0";
        } else {
          this.is_specOption = false;
        }
      }
    },
    // cateValue: function(val) {
    //   console.log("类目", val);
    //     // this.getscreen(this.cateValue);

    // },
    cateValue: {
      handler: function(val){
        console.log("类目bianh话", val);
        this.getscreen(this.cateValue)
      },
      immediate: true,
    }
  },
  mounted() {
    new BScroll(".bodycontent", {
      click: true,
      mouseWheel: true
    });
    this.getCate();
    this.getgoodsType();
    this.getFreightdata();
    // 获取编辑数据
    if(this.idE){
      var data = {
        token:this.token,
        id:this.idE,
        app_id: this.app_id
      }
      acquireProduct(data).then(res =>{
        this.initdata = res.data;
        // 分类
        this.cateValue = this.initdata.goods_cat_id;
        // this.cateValue.push(this.initdata.goods_cat_id);
        this.fileListData = this.initdata.image;//图片列表
        this.fakefileList = this.initdata.image;
        this.chosepictireid = this.initdata.image_id.split(",");
        console.log("图片数组",this.chosepictireid);
        if(this.initdata.video_id != ""){
          this.videoUrl = this.initdata.video[0].url;//视频列表
          this.is_video = true;
        }
        this.initdata.is_new = String(this.initdata.is_new);
        this.initdata.is_spec = String(this.initdata.is_spec);
        this.is_sales = this.initdata.is_sale_show == 1? true : false;
        if(this.initdata.is_spec == "1"){
          this.specOptiondata = this.initdata.product;
          var arr = this.initdata.product;
          for(var i = 0; i < arr.length; i++){
            this.specOptiondata[i].imageUrl = arr[i].image[0].url;
            this.specOptiondata[i].is_defalut = arr[i].is_defalut == 0 ? false: true;
          }
        }

        // 邮费
        if(this.initdata.goods_type_id == 1){
          let arr = this.initdata.normal;
          this.postage_free_ship = String(arr.free_ship);
          this.initdata.send_method = String(arr.send_method);
          this.initdata.send_tlp_id = arr.send_tlp_id;
        }
        console.log("属性列表",this.drawattrList);
        // 

        this.goods_group_id = String(this.initdata.goods_group_id)//商品分组
        this.initdata.brand_id = String(this.initdata.brand_id)//商品品牌
        // commonValue(classid, send, name)
        this.commonValue(2, this.initdata.goods_attr, this.drawattrList);
        this.commonValue(4, this.initdata.goods_params, this.drawParamList);
        this.commonValue(5, this.initdata.goods_service, this.drawServeList);
        this.commonValue(3, this.initdata.goods_inner_attr, this.drawww);
        this.getInnerAttrName(1);
        this.getParamName(1);
        this.getServeName(1);
        this.initdata.label_ids = this.initdata.label_ids * 1;
        this.initdata.cal_stock_meth = String(this.initdata.cal_stock_meth);
        this.initdata.marketable = String(this.initdata.marketable);
        console.log(this.initdata);
        console.log("邮费",this.postage_free_ship);
        console.log("初始化数据");
        return this.initdata.send_tlp_id;
      })
    }else{
      this.$message({
        type: 'warning',
        message: 'error'
      });
      this.$router.back(-1);
    }
    // 分组数据
    this.getgroupList();
    //标签数据
    this.getlabeldata();
  },
  methods: {
    // 新增窗口
    windowOpen(index){
      switch (index){
        case 1:
          var url = "/apply/mallManagement/system/distribution/expressage/freightSet";
          break;
        case 2:
          var url = "/apply/mallManagement/mall/group";
          break;

      }
      window.open(url);
    },
    refersh(){
      this.getFreightdata();
      this.getShowPostageSet();
    },
    handleCheckAllChange(value, index) {
      console.log("全选",value, index);
      if(value == true){
        this.choseCheckout[index] = [];
        var aa = this.catedataitem[index].params;
        for(var i= 0; i < aa.length; i ++){
          this.choseCheckout[index].push(aa[i].id);
        }
        this.isIndeterminate[index] = false;
        this.checkallss[index] = true;
      }else{
        this.choseCheckout[index] = [];
      }
      this.$set(this.choseCheckout, index, this.choseCheckout[index]);
      this.handleCheckedCitiesChange();
    },
    handleCheckedCitiesChange() {
      console.log("组", this.choseCheckout);
      this.choseData = [];
      var aa = this.catedataitem;
      var bb = [];
      //点击区域已选处理 
      for(var j = 0; j < this.choseCheckout.length; j ++){
        // 全选
        if(this.catedataitem[j].params.length == this.choseCheckout[j].length){
          this.isIndeterminate[j] = false;
          this.checkallss[j] = true;
        }else if(this.choseCheckout[j].length > 0){
          this.isIndeterminate[j] = true;
          this.checkallss[j] = true;
        }else{
          this.checkallss[j] = false;
          this.isIndeterminate[j] = false;
        }
        for(var h = 0; h < this.choseCheckout[j].length; h ++){
          this.$set(this.choseCheckout[j], h, this.choseCheckout[j][h]);

          bb.push(this.choseCheckout[j][h]);
        }
      }
      // 已选
      for( var i = 0; i < aa.length; i ++){
        for(var f = 0; f < aa[i].params.length; f ++){
          for(var g= 0; g < bb.length; g ++){
            if(aa[i].params[f].id * 1 == bb[g]){
              this.choseData.push(aa[i].params[f]);
              break;
            }
          }
        }
      }
    },
    // 切换
    cutConF(index){
      this.is_check = index;
    },
    // 类目变化
    setFilter(val){
      if(this.cateValue.length == 0){
        this.$message.warning("您还没有选择商品分类，请先选择，在进行筛选！！")
      }else{
        this.is_filter = true;

        // var id = "";
        // if(typeof(this.cateValue) != "number"){
        //   id = this.cateValue[this.cateValue.length - 1];
        // }else{
        //   id = this.cateValue;
        // }
        // console.log("选中的分类id", id);
        
        // console.log("rrrrff", as);
        
      }
    },
    //获取筛选
    getscreen(id = 0){
      if(id != 0){
        let data = {
          token : this.token,
          app_id : this.app_id,
          id: id,
        }
        getDeatil(data).then( res => {
          console.log("类目data", res);
          if(res.data.search_group.length > 0){
            this.catedataitem = res.data.search_group;
            // let aa = this.cateData.params
            // this.cateData.params.forEach(element => {
            //   console.log("femlei",element);
            // });
            let aa = this.catedataitem;
            // console.log("111choaaaa",aa)
            for(var i = 0; i < aa.length ; i ++){
              this.choseCheckout[i] =[];
              this.checkallss[i] = true;
              this.isIndeterminate[i] = true;
              console.log("类目data", res);
              var serchGroup = this.initdata.search_group;
              if(serchGroup.length > 0){
                for(var f = 0; f < serchGroup.length; f++){
                  if(aa[i].id == serchGroup[f].group_id){
                    this.choseCheckout[i].push(serchGroup[f].params_id); 
                  }
                }
                // this.choseCheckout[i].push()
              }
              // if()
            }
              console.log("111chose",this.choseCheckout)
            this.handleCheckedCitiesChange();
          }
        })
      }
      
    },
    // 关闭弹窗
    Fclose(val){
      console.log("子组件传过来的值", val);
      this.is_collectPop = val;
      this.collectPopValue = "";
    },
    // 整合数据
    commonValue(classId, senddata, namedata){
      var attr = senddata;
      var arrays = [];
      if(attr.length >= 0){
        for(let i = 0; i< attr.length; i++){
          namedata.push(attr[i].parent);
          namedata[i].val = attr[i].id;
          let id = attr[i].parent.id;
          switch(classId){
            case 2:
              this.getAttrValue(id);
            break;
            case 3:
              this.getInnerAttrValue(id);
            break;
            case 4:
              this.getParamValue(id);
            break;
            case 5:
              this.getServeValue(id);
            break;
          }
        }
      }
    },
    // 去重复的名字值
    Removerepeat(fall, part){
      var arr = fall;
      var draw = part;
      for(var i = 0; i < draw.length; i ++){
        for(var j = 0; j < arr.length; j ++){
          if(arr[j].id == draw[i].id){
            arr.splice(i, 1);
            break;
          }
        }
      }
      return arr;
    },
    // 提示
    changeMethods(index){
      console.log("是否包邮", index);
      if(index == "0"){
        this.$confirm("确定要更换吗? 之前数据将进行清空!!", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }).then(() => {
          this.initdata.send_tlp_id = "";
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消开启"
          });
        });
      }
    },
    // 分类数据
    getCate(){
      let data = {
          token: this.token,
          app_id: this.app_id,
      };
      getCateApi(data).then(res => {
        if (res.code == 200) {
          this.catedata = res.data;
        }
      })
    },
    // 分类选择
    handleChangeCate(value) {
      this.judecate = true;
      console.log("我变化了",value);
    },
    // 商品多规格、
    changeIsDefault(index){
      console.log("guige",index);
      for(let i = 0; i < this.specOptiondata.length; i++){
        if(i != index){
          this.specOptiondata[i].is_defalut = false;
          this.$set(this.specOptiondata, i, this.specOptiondata[i]);
        }
      }
      console.log("withoutqq",this.specOptiondata);
    },
    upload_index_img(file, index){
      var that = this;
      var formdata = new FormData();
      formdata.append('token', that.token);
      formdata.append('image', file.file);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      addImage(formdata).then(res => {
        var data = res.data;
        if(res.code == 200){
          that.specOptiondata[index].image_id = data.id;
          that.specOptiondata[index].imageUrl = data.url;
          that.$set(that.specOptiondata, index, that.specOptiondata[index]);
        }else{
          this.$message.warning(res.msg);
        }
        
      });
    },
    // 获取运费模板
    getFreightdata(){
      let data = {
        "token":this.token,
        "app_id":this.app_id,
        "merch_id":this.merch_id,
      }
      getFreights(data).then(res =>{
        console.log("state",res);
        if(res.code == 200){
          this.freightdata = res.data;
          // var f = this.freightdata;
          // for(var i = 0; i < f.length; i++){
          //   if(f[i].is_defautl == 1){
          //     this.viewFreight = f[i];
          //     this.dataArray.goods.send_tlp_id = f[i].id;
          //     break;
          //   }
          // }
        }
      })
    },
    // 获取邮费设置
    getShowPostageSet(){
      let data = {
        token: this.token,
        app_id: this.app_id,
      } 
      showPostageSet(data).then(res => {
        console.log("获取邮费设置", res);
        if(res.code == 200){
          let data = res.data;
          if(data.freight_type == "1"){
            this.$message.warning("您还没有设置统一模板");
          }else{
            this.initdata.send_tlp_id = data.freight_id;
          }
        }
      })
    },
    // 
    changeFreight(val){
      if(this.freightdata){
        let f = this.freightdata;
        for(var i = 0; i < f.length; i++){
          if(f[i].id == val){
            this.viewFreight = f[i];
            break;
          }
        }
      }
    },
    // 获取商品分组列表
    getgroupList(){
      let data = {
          token: this.token,
          app_id: this.app_id,
          store_id: "0",
          merch_id: this.merch_id,
          name: this.screenInput
        };
      groupList(data).then(res => {
        console.log("分组数据",res);
        this.groupdata = res.data;
      });
    },
    // 获取标签数据
    getlabeldata(){
      let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: this.merch_id,
          name: this.screenInput
        };
      getLabeldataApi(data).then(res => {
        console.log(res);
        this.labeldata = res.data;
      });
    },
    // 获取品牌列表
    getBrandList(){
      let data = {
          token: this.token,
          app_id: this.app_id,
          merch_id: this.merch_id,
        };
      BrandList(data).then(res => {
        console.log(res);
        this.branddata = res.data;
      });
    },
    // 获取对应的商品信息 1 商品分组 2 商品属性 4 商品参数 5 商品服务
    againshopdatat(index) {
      var that = this;
      console.log("获取对应的商品信息", index);
      switch (index) {
        case 3:
          if (that.ww.length == 0) {
            that.getInnerAttrName();
          }                                                                                                            
          break;
        case 4:
          if (that.drawParamValueList.length == 0) {
            that.getParamName();
          }                                                                                                            
          break;
        case 5:
          if (that.drawServeValueList.length == 0) {
            that.getServeName();
          }                                                                                                        
          break;
      }
    },
    // 把获取的数据增加到内容存储区域
    addstockItem(classId, index, id, name){
      switch(classId){
        case 2:
          var obj = {};
          obj.name = name;
          obj.val = ""; //值id
          obj.id = id; //父级ID后期更改名字
          this.drawattrList.push(obj);
          this.getattrList.splice(index, 1);
          this.getAttrValue(id);
          this.show_replaceAttrNEW = true;
        break;
        case 3:
          var obj = {};
          obj.name = name;
          obj.val = "";
          obj.id = id;
          this.drawww.push(obj);
          this.innerhtmldata.splice(index, 1);
          this.getInnerAttrValue(id);
          this.show_replaceInnerAttrNEW = true;
        break;
        case 4:
          var obj = {};
          obj.name = name;
          obj.val = "";
          obj.id = id;
          this.drawParamList.push(obj);
          this.getParamList.splice(index, 1);
          this.getParamValue(id);
          this.show_replaceParamNEW = true;
        break;
        case 5:
          var obj = {};
          obj.name = name;
          obj.val = "";
          obj.id = id;
          this.drawServeList.push(obj);
          this.getServeList.splice(index, 1);
          this.getServeValue(id);
          this.show_replaceServeNEW = true;
        break;
      }
    },
    // 移除存储区域的内容
    drawattrDelect(classId, index){
      var that =  this;
      switch(classId){
        case 2:
          that.drawattrList.splice(index,1);
          that.drawattrValueList.splice(index,1);
        break;
        case 3:
          that.drawww.splice(index,1);
          that.ww.splice(index,1);
        break;
        case 4:
          that.drawParamList.splice(index,1);
          that.drawParamValueList.splice(index,1);
        break;
        case 5:
          that.drawServeList.splice(index,1);
          that.drawServeValueList.splice(index,1);
        break;
      }
    },
    // 操作区域的新增按钮方法
    addattritem(classId) {
      let BeCofirmValue = ""
      switch (classId){
        case 2:
          BeCofirmValue = "attritemName";
        break;
        case 3:
          BeCofirmValue = "innerattritemName";
        break;
        case 4:
          BeCofirmValue = "paramitemName";
        break;
        case 5:
          BeCofirmValue = "serveitemName";
        break;
      }
      var value = document.getElementsByName(BeCofirmValue);
      console.log("input值操作区域", value[0].value);
      // 判断有误 -》暂时的
      if (value[0].value == " ") {
        this.$message({
          type: "warning",
          message: "请输入要增加的值"
        });
      } else {
        this.collectPopId = classId;
        this.is_collectPop = true;
        this.collectPopValue = value[0].value;
        console.log("传给自组建的值", this.collectPopValue)
        // 调用上传
        switch (classId){
          case 2:
            this.collectPopTitle =""
          break;
          case 3:
            this.collectPopTitle = "商品内部属性";
          break;
          case 4:
            this.collectPopTitle = "商品参数";
          break;
          case 5:
            this.collectPopTitle = "商品服务";
          break;
        }
      }
    },
    // 内容区域的新增按钮方法
    addattrValueitem(classId, pid, index) {
      let BeCofirmValue = ""
      switch (classId){
        case 2:
          BeCofirmValue = "attritemValue";
        break;
        case 3:
          BeCofirmValue = "innerattritemValue";
        break;
        case 4:
          BeCofirmValue = "paramitemValue";
        break;
        case 5:
          BeCofirmValue = "serveitemValue";
        break;
      }
      var value = document.getElementsByName(BeCofirmValue);
      console.log("input值", this.drawww);
      console.log("input值dfgv列表", value);
      console.log("input值dfgv", value[index].value);
      if (!value[index].value) {
        this.$message({
          type: "warning",
          message: "请输入要增加的属性值"
        });
      } else {
        switch (classId){
          case 2:
            this.getAddAttrValue(pid, value[index].value, index);
            value[index].value = "";
          break;
          case 3:
            this.getInnerAddAttrValue(pid, value[index].value, index);
            value[index].value = "";
          break;
          case 4:
            this.getAddParamValue(pid, value[index].value, index);
            value[index].value = "";
          break;
          case 5:
            this.getAddServeValue(pid, value[index].value, index);
            value[index].value = "";
          break;
        }
      }
    },
    // replaceNEW切换新增属性
    replaceNEW(classId) {
      switch (classId){
        case 2:
          this.show_replaceAttrNEW = false;
        break;
        case 3:
          this.show_replaceInnerAttrNEW = false;
        break;
        case 4:
          this.show_replaceParamNEW = false;
        break;
        case 5:
          this.show_replaceServeNEW = false;
        break;
      }
    },
    //属性 start
    // 获取商品属性名列表
    // getAttrName(jude = 0) {
    //   let data = {
    //     token: this.token,
    //     app_id: this.app_id,
    //     merch_id: this.merch_id
    //   };
    //   getAttrNameApi(data).then(res => {
    //     if(jude == 0){
    //       if (res.code == 1)
    //       this.getattrList = res.data;
    //     }else{
    //       this.getattrList = this.Removerepeat(res.data, this.drawattrList);
    //     }
        
    //   });
    // },
    // 获取商品属性对应值列表 
    getAttrValue(id, jude = 0, index = "") {
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: id
      };
      getAttrValueApi(data).then(res => {
        if (res.code == 1 && jude == 0) {
          let newARR = res.data;
          this.drawattrValueList.push(newARR);
        } else if (res.code == 1 && jude == 1){
          this.drawattrValueList[index] = res.data;
          this.$set(this.drawattrValueList,index,this.drawattrValueList[index]);
        }else{
          console.log("error");
        }
      });
      
    },
    // 增加商品属性值
    getAddAttrValue(pid, name, index){
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: pid,
        name:name,
      }
      getAddAttrValueApi(data).then(res =>{
        console.log("zengjia商品属性值",res);
        if(res.code == 1)
          this.$message({
            type: "warning",
            message: res.msg
          });
          // 重新查找赋值
          this.getAttrValue(pid,1,index);
      })

    },
    // 属性 end
    // canshu
    // 获取商品参数名列表
    getParamName(jude = 0) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id
      };
      getParamNameApi(data).then(res => {
        if(jude == 0){
          if (res.code == 1)
          this.getParamList = res.data;
        }else{
          this.getParamList = this.Removerepeat(res.data, this.drawParamList);
        }
        if (res.code == 1)
        this.getParamList = res.data;
      });
    },
    // 获取商品参数对应值列表 
    getParamValue(id, jude = 0, index = "") {
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: id
      };
      getParamValueApi(data).then(res => {
        if (res.code == 1 && jude == 0) {
          let newARR = res.data;
          this.drawParamValueList.push(newARR);
        } else if (res.code == 1 && jude == 1){
          this.drawParamValueList[index] = res.data;
          this.$set(this.drawParamValueList,index,this.drawParamValueList[index]);
        }else{
          console.log("error");
        }
      });
      
    },
    // 增加商品参数值
    getAddParamValue(pid, name, index){
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: pid,
        name:name,
      }
      getAddParamValueApi(data).then(res =>{
        if(res.code == 1)
          this.$message({
            type: "warning",
            message: res.msg
          });
          // 重新查找赋值
          this.getParamValue(pid,1,index);
      })

    },
    // canshuend
    // 内部属性 strat
    // 获取商品内部属性名列表
    getInnerAttrName(jude = 0) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id
      };
      getInnerAttrNameApi(data).then(res => {
        if(jude == 0){
          if (res.code == 1)
          this.innerhtmldata = res.data;
        }else{
          this.innerhtmldata = this.Removerepeat(res.data, this.drawww);
        }
      });
    },
    // 获取商品内部属性对应值列表 
    getInnerAttrValue(id, jude = 0, index = "") {
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: id
      };
      console.log("传递至",id,jude,index);
      getInnerAttrValueApi(data).then(res => {
        if (res.code == 1 && jude == 0) {
          console.log(res);
          console.log("old",this.ww);
          let newARR = res.data;
          this.ww.push(newARR);
          console.log("new",this.ww);
        } else if (res.code == 1 && jude == 1){
          this.ww[index] = res.data;
          this.$set(this.ww,index,this.ww[index]);
        }else{
          console.log("error");
        }
      });
    },
    // 增加neibu商品属性值
    getInnerAddAttrValue(pid, name, index){
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: pid,
        name:name,
      }
      console.log("产过来的数据",pid,name,index);
      getAddInnerAttrValueApi(data).then(res =>{
        console.log("zengjia商品属性值",res);
        if(res.code == 1)
          this.$message({
            type: "warning",
            message: res.msg
          });
          // 重新查找赋值
          this.getInnerAttrValue(pid,1,index);
      })
    },
    // 内部属性 end
    // 服务 start
    // 获取商品服务列表 
    getServeName(jude = 0) {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id
      };
      getServeNameApi(data).then(res => {
        if(jude == 0){
          if (res.code == 1)
          this.getServeList = res.data;
          console.log("dfd",jude);
        }else{
          console.log("dfd11111111",jude);
          this.getServeList = this.Removerepeat(res.data, this.drawServeList);
        }
      });
    },
    // 获取商品服务对应值列表 
    getServeValue(id, jude = 0, index = "") {
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: id
      };
      getServeValueApi(data).then(res => {
        if (res.code == 1 && jude == 0) {
          let newARR = res.data;
          this.drawServeValueList.push(newARR);
        } else if (res.code == 1 && jude == 1){
          this.drawServeValueList[index] = res.data;
          this.$set(this.drawServeValueList,index,this.drawServeValueList[index]);
        }else{
          console.log("error");
        }
      }); 
    },
    // 增加商品服务值
    getAddServeValue(pid, name, index){
      let data = {
        token: this.token,
        app_id: this.app_id,
        pid: pid,
        name:name,
      }
      getAddServeValueApi(data).then(res =>{
        console.log("zengjia商品参数值",res);
        if(res.code == 1)
          this.$message({
            type: "warning",
            message: res.msg
          });
          // 重新查找赋值
          this.getServeValue(pid,1,index);
      })

    },
    // 服务 end
    // 删除规格
    delectSpec(index){
      this.specOptiondata.splice(index, 1);
      console.log("规格行数   ---》"+ index);
    },
    // 编辑器
    changeeditor(val) {
      this.initdata.intro = val;
      console.log(this.initdata.intro);
    },
    // 是否开启多规格
    is_specMessageBox(val) {
      console.log("chuanguolaidezhi ",val);
      this.$confirm("更换类型后，货品需重新生成, 确定要更换吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        // 选中类型的数据
        console.log("商品类型 id ----"+val);
        this.getSpecData(val);
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消开启"
        });
      });
    },

    // 获取商品类型
    getgoodsType(){
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        page: this.page
      };
      TypeList(data).then(res => {
        if(res.code == 1){
          this.goodsType = res.data;
          console.log("商品类型",res);
        }
      });
    },
    // 获取多规格组合
    getSpecData(val){
      var that = this;
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: this.merch_id,
        type_id: val,
      };
      Getspec(data).then(res => {
        console.log(res);
        if(res.code == 1){
          var arrays = res.data;
          console.log(res.data);
          arrays.forEach(element => {
            let obj = {
              sn: "",
              price: "",
              costprice: "",
              mktprice: "",
              stock: "",
              is_defalut: "",
              image_id: "",
              spes_desc: "",
              imageUrl: "",
            };
            obj.spes_desc = element;
            that.specOptiondata.push(obj);
          });
          console.log("规格数据ss",that.specOptiondata);
        }
      });
      console.log("多规格组合");
    },
    // 选择商品类目
    handleChange(value) {
      console.log(value);
    },
    // 选择商品类别
    clickchose(index) {
      this.choseIndex = index;
      this.goods_type = index;
    },
    // 商品图片
    handleRemove(file) {
      //  图片删除同步更改列表
      var replaceArr = this.fakefileList;
      for(var i= 0; i < replaceArr.length; i++){
        if(file.uid == replaceArr[i].uid){
          replaceArr.splice(i,1);
          this.chosepictireid.splice(i,1);
          this.initdata.image_id = this.chosepictireid.join(',');
          console.log(this.initdata.image_id,"dffffffff");
          break;
        }
      }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 选取视频时的调用
    changeVideo(){
      var v = this.$refs.videitem.files[0];
      // 大小
      var size = v.size;
      if(size > 5242880){
        this.$message({
          message: '视频文件太大，请重新选择',
          type: "warning"
        });
        return false;
      }
      var index = v.name.indexOf(".") + 1;
      var suffix = v.name.slice(index);
      if(suffix != "mp4"){
        this.$message({
          message: '请选择正确的视频格式',
          type: "warning"
        });
        return false;
      }
      var formdata = new FormData();
      formdata.append('token', this.token);
      formdata.append('video', v);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      this.videodata = formdata;
      var url = URL.createObjectURL(v);
      this.videoUrl = url;
      this.is_video=true;
      addVideo(this.videodata).then(res => {
        this.initdata.video_id = res.data.id; //id
        console.log("视频上传id----" + this.initdata.video_id);
      });
    },
    // 操作按钮 0 取消 1 上一步 2 下一步 3 保存 
    operation(index){
      // let pageNum = this.progressStatus
      switch(index){
        case 0:
          this.$router.push("manage");
          break;
        case 1:
          this.progressStatus = String(parseInt(this.progressStatus) - 1);
          break;
        case 2:
          // 第一个下一步
          if (this.progressStatus == 1) {
            var that = this;
            // 判断必填项
            if (this.initdata.name == "") {
              this.$message({
                message: '请填写商品名称',
                type: "warning"
              });
              return false;
            } else if (that.initdata.image_id == "") {
              this.$message({
                message: "图片不能为空",
                type: "warning"
              });
              return false;
            }
            // 判断多规格
            if(this.initdata.is_spec == "1"){
              var specdata = that.specOptiondata;
              for(var i = 0; i < specdata.length; i++){
                console.log("多规格数据",specdata[i]);
                if (
                  specdata[i].imageUrl == "" ||
                  !specdata[i].image_id ||
                  !specdata[i].sn ||
                  !specdata[i].price ||
                  !specdata[i].costprice ||
                  !specdata[i].mktprice ||
                  !specdata[i].stock ||
                  !specdata[i].spes_desc
                ) {
                  this.$message({
                    message: '请完善多规格信息',
                    type: "warning"
                  });
                  return false;
                }
              }
            }
          }
          this.progressStatus = String(parseInt(this.progressStatus) + 1);
          this.fileListData=this.fakefileList;
          console.log(this.fileListData,"商品图片列表");
          this.fileListData = this.fakefileList;
          break;
        default:
          this.posteditProduct();
      }
    },
    // 编辑器
    change(val) {
      console.log(val);
    },
    //上传商品图片
    productUploadImg(file){
      var that = this;
      var formdata = new FormData();
      formdata.append('token', that.token);
      formdata.append('image', file.file);
      formdata.append('type', "1");
      formdata.append('file_group', "1");
      addImage(formdata).then(res => {
        console.log("上传回调",res);
        var data = res.data;
        if(res.code == 200){
          this.chosepictireid.push(res.data.id);
          this.initdata.image_id = this.chosepictireid.join(',');
          var list = {};
          var index = 0;
          list.name = res.data.key;
          list.url = res.data.url;
          // 图片列表
          this.fakefileList.push(list);
        }else{
          this.$message({
            message: res.msg,
            type: "warning"
          });
        }
      });
    },
    // 编辑商品
    posteditProduct(){
      var that = this;
      var data = {
        // goods_id:that.idE,
        token:that.token,
        app_id:that.app_id,
        goods:{},
        product:{
          stock: "",//多规格库存
          spes_desc:"",//多规格
          image_id:"",//多规格图片
          sn:"",//多规格编号
          price:"",//多规格价格
          costprice:"",//多规格成本价
          mktprice:"",//多规格市场价
          is_defalut:"",//多规格默认
          id:"",//id
        }
      };
       // 分类
      if(that.judecate){
        var cateId = that.cateValue.length - 1;
        that.initdata.goods_cat_id = that.cateValue[cateId];
      }
      console.log("分类", that.initdata.goods_cat_id);
      // 销量
      var sals = that.is_sales == true ? 1 : 0;
      that.initdata.is_sale_show = sals;
      // 是否包邮
      that.initdata.free_ship = that.postage_free_ship;
      //多规格
      if(that.initdata.is_spec == "1"){
        var specdatas = that.specOptiondata;
        console.log("多规格数据",specdatas);
        var spec =[];
        var imageid =[];
        var sn =[];
        var price =[];
        var costprice =[];
        var mktprice =[];
        var is_defalut =[];
        var stock =[];
        var id =[];
        for(var i = 0 ; i < specdatas.length; i++){
          spec.push(specdatas[i].spes_desc);
          imageid.push(specdatas[i].image_id);
          sn.push(specdatas[i].sn);
          price.push(specdatas[i].price);
          costprice.push(specdatas[i].costprice);
          mktprice.push(specdatas[i].mktprice);
          is_defalut.push(specdatas[i].is_defalut == true? "1": "0");
          stock.push(specdatas[i].stock);
          id.push(specdatas[i].id);
        }
        data.product.spes_desc = spec;
        data.product.image_id = imageid;
        data.product.sn = sn;
        data.product.price = price;
        data.product.costprice = costprice;
        data.product.mktprice = mktprice;
        data.product.is_defalut = is_defalut;
        data.product.stock = stock;
        data.product.id = id;
        console.log("整合的多规格数据",data.product);
      }
      var attr = that.drawattrList;
      var innerattr = that.drawww;
      var param = that.drawParamList;
      var serve = that.drawServeList;
      that.initdata.goods_attr = that.dislosedata(attr);
      that.initdata.goods_inner_attr = that.dislosedata(innerattr);
      that.initdata.goods_params = that.dislosedata(param);
      that.initdata.goods_service = that.dislosedata(serve);
      that.initdata.search_group = this.choseData;
      that.initdata.goods_id = that.idE;

      var oldarray = that.initdata;
      for(var item in oldarray){
        if(item == "product" || item == "update_time" || item == "uptime" || item == "create_time"){
          continue;
        }
        data.goods[item] = oldarray[item];
      }
      console.log(data);
      console.log(that.initdata);
      console.log("我是要上传的数据啊");
      // return ;
      editProduct(data).then(res=>{
        if(res.code == 200){
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.$router.back(-1);

        }else{
          this.$message({
            message: "编辑商品失败",
            type: 'warning'
          });
        }
      })
    },
    // 处理数据
    dislosedata (val){
      // console.log(varl);
      // return;
      var arrays = [];
      var data = val;
      if(data.length != 0){
        for(var i =0; i < data.length; i++){
          arrays.push(data[i].val);
        }
        return arrays.join(",");
      }else{
        return "";
      }
    }
      
  }
};
</script>
<style lang="scss">
.bodycontent .boxposition {
  .el-upload {
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px !important;
    height: 80px !important;
    line-height: 80px !important;
  }
}
</style>
<style lang="scss" scoped>
@import "./public/style/_interfacePublic";
// 通用样式
.smallinput {
  width: 140px;
}
.longinput {
  width: 80%;
}
.margin {
  margin-right: 10px;
}
.paddings {
  padding: 15px 0 15px 15px;
  background: #fff;
}
.link {
  color: #5b93ff;
  padding: 0 10px;
  cursor: pointer;
}
.groupcontent {
  background: #fff;
}
//视频上传框
.videdo {
  .videobox {
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 27px;
  }
  .againvideo {
    margin: 20px 0 0 20px;
    .but {
      width: 60px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      background: #67c23a;
      border-radius: 3px;
      color: #fff;
    }
  }
}
// 输入框
.import {
  height: 30px;
  input {
    width: 164px;
    height: 30px;
    font-size: 12px;
    border-radius: 5px 0 0 5px;
  }
  .newbutton {
    width: 40px;
    text-align: center;
    height: 30px;
    line-height: 30px;
    border: 1px solid #ccc;
    border-radius: 0 5px 5px 0;
  }
}
.content {
  position: relative;
  .bodycontent {
    font-size: 14px;
    width: calc(82vw - 34px);
    height: calc(100vh - 162px);
    overflow: hidden;
    background: #fff;
    .boxposition {
      padding-bottom: 50px;
    }
    /* 进度1 */
    .box1Progress,
    .box2Progress {
      width: calc(100% - 40px);
      background: #F2F2F6;
      padding: 20px 60px;
      margin: 10px 20px 0;
      .title {
        font-weight: 600;
        font-size: 14px;
      }
    }
    /* 类别 */
    .classify {
      // height: 100px;
      display: flex;
      align-items: center;
      margin: 35px 0 ;
      .classifyItem {
        width: 150px;
        height: 60px;
        text-align: center;
        margin-right: 20px;
        font-size:12px;
        position: relative;
        border: 1px solid #ccc;
        background: #fff;
        /* 角标 */
        .iconfont {
          color: #5b93ff;
          font-size: 23px;
          padding: 0;
          width: 24px;
          height: 24px;
          position: absolute;
          right: -2px;
          bottom: 0;
        }
        p {
          padding-top:10px;
        }
        p:nth-child(2) {
          color: #ccc;
        }
      }
      .opt {
        border: 1px solid #5b93ff;
      }
    }
    // 当前类目
    .present {
      display: flex;
      .block {
        display: flex;
        .demonstration {
          width: 110px;
          text-align: right;
          margin-right: 45px;
        }
      }
    }
    /* 商品信息 */
    .message {
      .messageUl {
        width: 100%;
        // padding-left:50px;
        color: #595959;
        .messageIl {
          display: flex;
          margin-top: 25px;
          .lileft {
            width: 110px;
            text-align: right;
            .redopt {
              color: red;
              font-size: 10px;
            }
          }
          .flex {
            display: flex !important;
            align-items: center;
          }
          .liright {
            flex: 1;
            font-size: 12px;
            color: #999999;
            margin-left: 45px;
            .secondLength {
              width: 400px;
              height: 30px;
              border: 1px solid #f1f1f1;
            }
            // 规格列表
            .speclist {
              width: 100%;
              border: 1px solid #ccc;
              tr {
                border-bottom: 1px solid #ccc;
                td {
                  min-width: 100px;
                  padding: 10px 10px;
                  input {
                    width: 90px;
                    height: 30px;
                    border-radius: 5px;
                    font-size: 10px;
                  }
                }
              }
              thead {
                background: #ccc;
              }
            }
          }
          /* 价格 */
          .averageLayout {
            /* display:flex; */
            color: #595959;
            span {
              margin-right: 20px;
              .el-input {
                width: 140px;
              }
            }
          }
          /* 商品属性的新增后的选择 */
          .chooseButton {
            background: #fff;
            /* 选中的内容储存区域 */
            .stockpile {
              width: 100%;
              .stockpileUl {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                .stockpileLi {
                  width: 30%;
                  height: 30px;
                  display: flex;
                  // align-items: center;
                  margin: 10px 0;
                  .name {
                    padding: 4px 10px;
                  }
                  /* 选择 */
                  .stockpileLiSelect {
                    flex: 1;
                    border-radius: 5px;
                    margin-right: 15px;
                    position: relative;
                    .showclick {
                      height: 30px;
                      border: 1px solid #f1f1f1;
                    }
                    .stockpileLiSelectItem {
                      width: 100%;
                      position: absolute;
                      top: 28px;
                      min-height: 82px;
                      border: 1px solid #f1f1f1;
                      z-index: 11;
                      background: #fff;
                      .import {
                        padding: 10px 30px;
                        /* text-align:center; */
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border: 0;
                        input {
                          height: 26px;
                          flex: 1;
                          border: 1px solid #f1f1f1;
                        }
                        .button {
                          width: 65px;
                          height: 26px;
                          line-height: 26px;
                          border-radius: 2px;
                          text-align: center;
                          border: 1px solid #e3e2e5;
                        }
                      }
                      .ajaxdata {
                        width: 100%;
                        border: 1px solid #f1f1f1;
                        /* 提示 */
                        .empty {
                          height: 100px;
                          line-height: 100px;
                          text-align: center;
                          font-size: 14px;
                          background: #fff;
                          p {
                            height: 20px;
                          }
                        }
                        li {
                          height: 26px;
                          text-align: center;
                        }
                      }
                    }
                  }
                }
              }
            }
            /* 操作区域 */
            .operater {
              width: 100%;
              display: flex;
              .operaterItem {
                display: flex;
                height: 26px;
              }
              .operaterItemSelect {
                position: relative;
                input {
                  width: 150px;
                  height: 26px;
                }
                ol {
                  width: 150px;
                  position: absolute;
                  z-index: 11;
                  li {
                    height: 26px;
                    border: 1px solid #ff11ff;
                  }
                }
              }
              .button {
                height: 26px;
              }
            }
          }
        }
      }
      /* 运费模板 */
      .freightTemplate {
        border: 1px solid #f1f1f1;
        width: 80%;
        background: #fff;
        margin-top: 10px;
        tr {
          height: 40px;
        }
      }
    }
    /* 下一步按钮 */
  }

  .next {
    width: calc(82vw - 22px);
    height: 50px;
    line-height: 50px;
    background: #fff;
    position: absolute;
    margin: -40px 0 0 -5px;
    text-align: center;
    border-top: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
  }
}
// 筛选项弹窗
.contFilter{
  min-height: 200px;
  display: flex;
  border: 1px solid #e3e2e5;
  .leftF{
    width: 60%;
    border-right: 1px solid #e3e2e5;
    .box{
      width: 100%;
      .topF{
        padding: 20px 20px 0 20px;
      }
      .contF{
        padding: 20px;
        .all{
          padding-bottom: 10px;
        }
      }
    }
  }
  .rightF{
    flex: 1;
    padding: 20px;
  }
}
</style>
